export type BaseResponse<T = unknown> = {
  success: boolean;
  data: T;
};

export type ApiBool = boolean | 0 | 1;
export interface Country {
  id: number;
  name: string;
  isPopular: boolean;
  position: number | null;
  visaRequired: boolean;
  visaOnline: boolean;
  resorts?: Resort[];
  visaDays: number | null;
  minPrice: number | null;
}
export interface NightsRange {
  from: number;
  to: number;
}

export interface DateRange {
  from: string;
  to: string;
  daysFlexible: number;
}

export interface Resort {
  id: number;
  name: string;
  countryId: number;
  countryName: string;
  isPopular: boolean;
  minPrice: number | null;
  atFiltering: boolean;
}

export interface Hotel {
  id: number;
  name: string;
  countryId: number;
  countryName: string;
}
export type DestinationKind = 'country' | 'resort' | 'hotel';
export type Destination = ({ type: 'country' } & Country) | ({ type: 'resort' } & Resort) | ({ type: 'hotel' } & Hotel);

export enum DepartureCityType {
  Capital = 'capital',
  Region = 'region',
}

export interface DepartureCity {
  id: number;
  name: string;
  type?: DepartureCityType;
  countriesWithDirectFlights?: number[];
}
export interface CityTypeCriteria {
  nights?: NightsRange;
  dateRange?: DateRange;
}

export interface CountryCriteria {
  capital?: CityTypeCriteria;
  region?: CityTypeCriteria;
}

export type DefaultCriteriaIndex = Record<number, CountryCriteria>;

export interface SearchFormData {
  countries: Country[];
  cities: DepartureCity[];
  defaultCriteria: DefaultCriteriaIndex;
}
export interface TouristGroupRoom {
  adults: number;
  ages: number[];
  infants: number;
  kids: number;
}

export interface SearchCriteriaParams {
  checkInDateRange: { from: string; to: string; daysFlexible?: number };
  countries: number[];
  departureCity: { id: number; name: string };
  nightRange: NightsRange;
  resorts?: number[];
  hotels?: number[];
  // Формат монолита: первая комната лежит плоско, остальные — в touristsByRooms.
  touristGroup: TouristGroupRoom & { touristsByRooms?: TouristGroupRoom[] };
}
